import type { Currency } from '@kanbu/schema/enums';
import { CreditCurrencyRates } from '@kanbu/schema/shared';

/**
 * Converts a price in a given currency to credits.
 */
export function convertCurrencyToCredits(price: number, currency: Currency) {
  return price / CreditCurrencyRates[currency];
}

/**
 * Converts credits to a price in a given currency.
 */
export function convertCreditsToCurrency(credits: number, currency: Currency) {
  const amount = credits * CreditCurrencyRates[currency];
  const rounded = Math.round(amount);

  /**
   * If the amount is within 0.1 of a whole number, round to that whole number
   * This handles cases like 899.07 -> 899
   */
  if (Math.abs(amount - rounded) < 0.1) {
    return rounded;
  }

  // Otherwise, round to 2 decimal places
  return Math.round(amount * 100) / 100;
}
